import React from "react";

/**
 * component svg
 */
const Forbidden = function (props) {
    return(
        <svg version="1.1" id="forbidden" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 1000 1000">
        <circle className="st0-forbidden" cx="500" cy="500" r="397"/>
        <g>
            <line className="st1-forbidden" x1="780.2" y1="780.2" x2="218.8" y2="218.8"/>
        </g>
        </svg>
    );
}

export default Forbidden;